import { Input, TimePicker, Button } from "@ds/ds-snam/react";
import { INotificationAction } from "dataModels/stateModels/notification";
import { IParametersFreezing } from "dataModels/settings";
import moment from "moment";
import { getParametersFreezing, putParametersFreezing } from "net/settings";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { AppUserRole, DsLayout, IAppUserProfile, TIME_FORMAT } from "shared/constants";
import { hideNotification, showNotification } from "state/reducer/notificationSlice";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";
import { RootState } from "state/appStore";
import useAppUser from "hooks/useAppUser";
import { AppUser } from "ooAuth2/appUser";


const defaultFormData : IParametersFreezing = {
    daysFreezing:0,
    limitFreezing:'00:00',
    limitFreezingFriday:'00:00',
    daysFreezingSales: 0, 
    limitFreezingSales:'00:00', 
    limitFreezingSalesFriday:'00:00', 
    daysShortTerm:0,
    limitShortTerm:'00:00',
    limitShortTermFriday:'00:00',
}

const FreezingShortView:React.FC<{}> = ():JSX.Element=>{
    const [formData,setFormData] = useState<IParametersFreezing>(defaultFormData);
    const dispatch = useDispatch();
    const { t } = useTranslation(['contract', 'app']);
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    const appUserProfile: IAppUserProfile | undefined = appUser?.userProfile;
    
    const onTimeInputChange = (inputEvent: Event,fieldName:string) => {
        //console.log((inputEvent as CustomEvent).detail.time)
        let currentData: IParametersFreezing = formData;
        //console.log(typeof currentData[fieldName as keyof IParametersFreezing])
        (currentData[fieldName as keyof IParametersFreezing] as string)=(inputEvent as CustomEvent).detail.time;
        setFormData(currentData);
    }




    const onTextInputChange = (inputEvent: Event) => {
        const fieldName = (inputEvent as CustomEvent).detail.input.name;
        let currentData: IParametersFreezing = formData;
        (currentData[fieldName as keyof IParametersFreezing] as number) = Number((inputEvent as CustomEvent).detail.input.value);
        setFormData(currentData);
    }

    const loadData = useCallback(() => {
        dispatch(requestPending());
        getParametersFreezing()
            .then((data: IParametersFreezing) => {
                setFormData(data);
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                dispatch(requestPristine())
            })
    }, [dispatch]);
    

    useEffect(() => {
        loadData()
    }, [loadData]);
    
    const putData = () => {
        //console.log(formData)
        let popUpAction: INotificationAction;
        dispatch(requestPending());
        putParametersFreezing(formData)
            .then(response => {
                popUpAction = {
                    show: true,
                    title: t('settings.slotFreezing.snackTitle'),//"Parametri freezing date e short term impostati correttamente",
                    description: t('settings.slotFreezing.snackText'),//"I parametri sono stati impostati correttamente",
                    status: "confirm",
                    onClose: (event: Event) => {
                        dispatch(hideNotification());
                    }
                };
                dispatch(showNotification(popUpAction));
                //navigate();
            }).catch((error) => {
                console.log(error)
            })
            .finally(() => {
                dispatch(requestPristine())
            });
    }

    const getRow = (
        inputTitle:string,
        inputValue:string,
        inputName:string,
        inputId:string,
        timePicketTitle:string,
        timePickerPlaceholder:string,
        defaultTime:string,
        timePickerInputChangeString:string,
        defaultTimeFriday:string,
        timePickerInputChangeStringFriday:string,
        timePickerPlaceholderFriday:string
    ) => {
        return(
            <>
                <Row>
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <Input
                                inputLabel={inputTitle} //"Giorni mancanti al servizio*"
                                inputValue={inputValue}
                                inputName={inputName}
                                inputId={inputId}
                                isNumberVariant={true}
                                isDisabled={appUserRole===AppUserRole.READER}
                                onInputChange={onTextInputChange}
                            ></Input>
                        </div>
                    </Col>
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TimePicker
                                startTime="00:00"
                                endTime="23:59"
                                timeInterval={60}
                                timePickerTitle={timePicketTitle} //"Orario limite*"
                                timePickerPlaceholder={timePickerPlaceholder} //"Seleziona orario"
                                isDisabled={appUserRole===AppUserRole.READER}
                                timePickerStatus="default"
                                hasCloseButton={false}
                                isReadonly={false}
                                defaultTime={defaultTime}
                                isPanelTop={false}
                                onTimeSelection={(event: Event) => {
                                    onTimeInputChange(event,timePickerInputChangeString)
                                }}
                            />
                        </div>
                    </Col>

                    {/*Terza colonna*/}
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TimePicker
                                startTime="00:00"
                                endTime="23:59"
                                timeInterval={60}
                                timePickerTitle={timePickerPlaceholderFriday} //"Orario limite*"
                                timePickerPlaceholder={timePickerPlaceholder} //"Seleziona orario"
                                isDisabled={appUserRole===AppUserRole.READER}
                                timePickerStatus="default"
                                hasCloseButton={false}
                                isReadonly={false}
                                defaultTime={defaultTimeFriday}
                                isPanelTop={false}
                                onTimeSelection={(event: Event) => {
                                    onTimeInputChange(event,timePickerInputChangeStringFriday)
                                }}
                            />
                        </div>
                    </Col>
                </Row>
            </>
        );
    }


    return(
        <>
            <p className="pageTitle">
                {t('settings.slotFreezing.title')} {/*Freezing date e short term*/}
            </p>
            {/*<p className="pageSubTitle">
                {t('settings.slotFreezing.sub_title.0')} 
            </p>*/}
            <div className="listTableContainerGrey">


                {/**FREEZING COMMERICALE */}
                <Row>
                    <Col>
                        <p className="formSubTitle">
                            {t('settings.slotFreezing.sub_title.3')} {/*Inserisci i dettagli della freezing date commerciale*/}
                        </p>
                    </Col>
                </Row>
                {getRow(
                    t('settings.slotFreezing.leftDays'),
                    formData.daysFreezingSales.toString(),
                    "daysFreezingSales",
                    "input-id-daysFreezingSales",
                    t('settings.slotFreezing.timeLimit'),
                    t('settings.slotFreezing.timeSelect'),
                    formData.limitFreezingSales,
                    'limitFreezingSales',
                    formData.limitFreezingSalesFriday,
                    'limitFreezingSalesFriday',
                    t('settings.slotFreezing.timeLimitFriday'),
                )}


                {/**FREEZING OPERATIONAL */}
                <Row style={{marginTop:'32px'}}>
                    <Col>
                        <p className="formSubTitle">
                            {t('settings.slotFreezing.sub_title.1')} {/*Inserisci i dettagli della freezing date operativa*/}
                        </p>
                    </Col>
                </Row>
                {getRow(
                    t('settings.slotFreezing.leftDays'),
                    formData.daysFreezing.toString(),
                    "daysFreezing",
                    "input-id-daysFreezing",
                    t('settings.slotFreezing.timeLimit'),
                    t('settings.slotFreezing.timeSelect'),
                    formData.limitFreezing,
                    'limitFreezing',
                    formData.limitFreezingFriday,
                    'limitFreezingFriday',
                    t('settings.slotFreezing.timeLimitFriday'),
                )}

            

                {/**SHORT TERM */}
                <Row style={{marginTop:'32px'}}>
                    <Col>
                        <p className="formSubTitle">
                            {t('settings.slotFreezing.sub_title.2')} {/*Inserisci i dettagli dello short term*/}
                        </p>
                    </Col>
                </Row>
                {getRow(
                    t('settings.slotFreezing.leftDays'),
                    formData.daysShortTerm.toString(),
                    "daysShortTerm",
                    "input-id-daysShortTerm",
                    t('settings.slotFreezing.timeLimit'),
                    t('settings.slotFreezing.timeSelect'),
                    formData.limitShortTerm,
                    'limitShortTerm',
                    formData.limitShortTermFriday,
                    'limitShortTermFriday',
                    t('settings.slotFreezing.timeLimitFriday'),
                )}



            </div>
            <div style={{float:'right',paddingTop:'20px',paddingBottom:'20px'}}>
                <Button
                    buttonType="button"
                    buttonUIVariant="primary"
                    buttonSize="medium"
                    buttonLabel={t('general.buttons.config', { ns: 'app' })}
                    buttonIcon=""
                    isDisabled={appUserRole===AppUserRole.READER}
                    onClickEvent={(event: Event) => {
                        //console.log(formData)
                        putData();
                    }}
                />
            </div>
        </>
    );
}
export default FreezingShortView;

